<script>
export default {
  name: 'CiCatalogHome',
};
</script>
<template>
  <div>
    <router-view />
  </div>
</template>
